var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 167,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 79.5,
    r: 77,
    stroke: "#fff",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 45v75l80-38Z"
  })));
};
export { SvgPlayIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjciIGhlaWdodD0iMTY3IiBmaWxsPSJub25lIj4KICA8Y2lyY2xlIGN4PSI4My41IiBjeT0iNzkuNSIgcj0iNzciIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSI1IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01MCA0NSBMNTAgMTIwIEwxMzAgODIgWiIgZmlsbD0iI2ZmZiIgLz4KPC9zdmc+Cg==";